import React, {useContext} from "react"
import {FloatButton} from "antd";
import {EditNoteRounded} from "@mui/icons-material";
import {NavigationContext} from "../common/NavigationContext";

const FloatingOpenRightNavMobile = () => {
    const { setNavVisible, setIsNavShowingRight } = useContext(NavigationContext)

    return(
        <FloatButton
            icon={<EditNoteRounded fontSize={"inherit"} />}
            onClick={() => {
                setIsNavShowingRight(true)
                setNavVisible(true)
            }}
            tooltip={"Open Lesson Shortcuts"}
            aria-label={"Open Lesson Shortcuts"}
            className={'ch-right-nav-mobile-button'}
        />
    );
}

export default FloatingOpenRightNavMobile;
